// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getBadRequestErrorMessage = (error: any): string | null => {
	if (error && error.statusCode === 400) {
		return error.message;
	}
	return null;
};
